import { GridColDef } from "@mui/x-data-grid-premium";
import { ByzMuiCheckBox } from "src/components/core-components/mui/ByzMuiCheckBox";
import ByzMuiOpenProcessMenu from "src/components/core-components/mui/ByzMuiOpenProcessMenu";
import { useTranslate } from "src/locales";
//IDOGAN;452471;02052025 
export const useLatestDietColumns = (): GridColDef[] => {
  const { t } = useTranslate();
  return [
    {
      field: "select",
      headerName: t("patient-diet-procedures.pages.select"),
      width: 60,
      sortable: false,
      filterable: false,
      renderCell: () => <ByzMuiCheckBox />,
    },
    {
      field: "actions",
      headerName: "",
      width: 60,
      sortable: false,
      filterable: false,
      renderCell: () => <ByzMuiOpenProcessMenu menuItems={[]} hideHeaderTitle />,
    },
    {
      field: "sube",
      headerName: t("patient-diet-procedures.pages.branch"),
      width: 150,
    },
    {
      field: "ogun",
      headerName: t("patient-diet-procedures.pages.meal"),
      width: 120,
    },
    {
      field: "diyetTipi",
      headerName: t("patient-diet-procedures.pages.diet-type"),
      width: 150,
    },
    {
      field: "adi",
      headerName: t("patient-diet-procedures.pages.name"),
      width: 150,
    },
    {
      field: "not",
      headerName: t("patient-diet-procedures.pages.note"),
      width: 150,
    },
    {
      field: "sonDiyetTarihi",
      headerName: t("patient-diet-procedures.pages.last-diet-date"),
      width: 150,
    },
  ];
};

// Örnek satırlar: Son Diyet öğünündeki diyet verileri
export const latestDietRows = [
  {
    id: 1,
    sube: "Klinik A",
    ogun: "Son Diyet",
    diyetTipi: "Normal",
    adi: "Diyet Standart",
    not: "",
    sonDiyetTarihi: "13.03.2025",
  },
  {
    id: 2,
    sube: "Klinik A",
    ogun: "Son Diyet",
    diyetTipi: "Sulu Yemek",
    adi: "Sebze Çorbası",
    not: "",
    sonDiyetTarihi: "13.03.2025",
  },
  {
    id: 3,
    sube: "Klinik B",
    ogun: "Son Diyet",
    diyetTipi: "Vegan",
    adi: "Bakliyat Salatası",
    not: "",
    sonDiyetTarihi: "13.03.2025",
  },
  {
    id: 4,
    sube: "Klinik B",
    ogun: "Son Diyet",
    diyetTipi: "Glutensiz",
    adi: "Kinoa Tabule",
    not: "",
    sonDiyetTarihi: "13.03.2025",
  },
  {
    id: 5,
    sube: "Klinik C",
    ogun: "Son Diyet",
    diyetTipi: "Diyet Rasyon",
    adi: "Rasyon A",
    not: "",
    sonDiyetTarihi: "13.03.2025",
  },
];
